/**
 * Map GET /users/me (snake_case) to Zustand UserProfile (camelCase).
 */

import type { UserProfile } from '@/lib/validations/api-schemas';

export interface ApiUserProfile {
  user_id: string;
  email: string;
  display_name?: string | null;
  avatar_url?: string | null;
  role?: string;
  organization?: {
    organization_id: string;
    name: string;
  };
  next_navigation?: {
    eligible_for_next_shell: boolean;
    org_enabled: boolean;
    preview_enabled: boolean;
    global_emergency_classic: boolean;
    intent_review_enabled?: boolean;
  };
}

export function mapApiUserProfileToStore(apiUser: ApiUserProfile): UserProfile {
  return {
    userId: apiUser.user_id,
    email: apiUser.email,
    displayName: apiUser.display_name ?? null,
    avatarUrl: apiUser.avatar_url ?? null,
    organization: apiUser.organization
      ? {
          organizationId: apiUser.organization.organization_id,
          name: apiUser.organization.name,
          role: apiUser.role ?? 'member',
        }
      : undefined,
    ...(apiUser.next_navigation
      ? {
          nextNavigation: {
            eligibleForNextShell: apiUser.next_navigation.eligible_for_next_shell,
            orgEnabled: apiUser.next_navigation.org_enabled,
            previewEnabled: apiUser.next_navigation.preview_enabled,
            globalEmergencyClassic: apiUser.next_navigation.global_emergency_classic,
            ...(apiUser.next_navigation.intent_review_enabled !== undefined
              ? { intentReviewEnabled: apiUser.next_navigation.intent_review_enabled }
              : {}),
          },
        }
      : {}),
  };
}
